<template>
  <div>
    <Head title="Dashboard" />
    <h1 class="mb-8 text-3xl font-bold">Онлайн-трансляція уроку</h1>
    <hls-player :stream-url="hlsStreamUrl"></hls-player>

  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import HlsPlayer from '@/Shared/HlsPlayer.vue';

export default {
  components: {
    Head,
    HlsPlayer,
  },
  layout: Layout,
  data() {
    return {
      hlsStreamUrl: 'https://edu.intelschool.com.ua/hls/playlist.m3u8', // Adjust the URL
    };
  },

}
</script>
